export default "__VITE_ASSET__CKCZa9Qy__"